/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React, { Component } from 'react';
import _ from './translations';

/**
 *  HOC that is used to load a component as a chunk.
 *  TODO: Migrate this to use React.lazy and suspense
 */
export default function dynamicComponent(importComponent) {
    class DynamicComponent extends Component {
        constructor(props) {
            super(props);
            this.loadComponent = this.loadComponent.bind(this);
            this.state = {
                component: null,
            };
        }

        renderLoadFailed = () => (
            <div style={this.props.style} onClick={this.loadComponent}>
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        minHeight: '50px',
                        cursor: 'pointer',
                    }}
                >
                    <p style={{ textAlign: 'center' }}>
                        {_(
                            "This component failed to load, click here to try again. If it doesn't work, try cleaning your browser cache."
                        )}
                    </p>
                </div>
            </div>
        );

        async loadComponent() {
            try {
                let { default: component } = await importComponent();
                this.setState({
                    component: component,
                });
            } catch (e) {
                this.setState({
                    component: this.renderLoadFailed,
                });
            }
        }

        async componentDidMount() {
            this.loadComponent();
        }

        render() {
            const C = this.state.component;

            return C ? <C {...this.props} /> : null;
        }
    }

    return DynamicComponent;
}
